import React from 'react';
import { makeStyles } from '@material-ui/core';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { DateRangeOutlined } from '@material-ui/icons';

// Shared by DateRangePickerACCB. On narrow screens a long label used to wrap
// onto a second line, which pushed its first line above the field and ran the
// rest across the calendar icon. Keep it on one line and stop it before the
// icon; a label that still doesn't fit is cut with an ellipsis.
export const useDateFieldStyles = makeStyles(() => ({
  label: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    // 14px inset + 24px icon + 14px padding, plus a little air
    maxWidth: 'calc(100% - 60px)',
    // Once floated onto the border the label is scaled to 75%, so it may use
    // the full width less the notch padding
    '&.MuiInputLabel-shrink': {
      maxWidth: 'calc(133% - 32px)',
    },
  },
}));

export default function DatePickerACCB({ value, onChange, label = 'Date', fullWidth = true, minDate = new Date('1900-01-01'), maxDate = new Date('2100-12-31'), required = false, error = false, helperText = '', InputProps = {}, InputLabelProps = {} }) {
  const classes = useDateFieldStyles();

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <DatePicker
        required={required}
        views={['year', 'month', 'date']}
        inputVariant="outlined"
        size="small"
        fullWidth={fullWidth}
        label={label}
        placeholder="DD/MM/YYYY"
        format="dd/MM/yyyy"
        value={value}
        onChange={onChange}
        minDate={minDate}
        maxDate={maxDate}
        InputProps={{
          endAdornment: <DateRangeOutlined style={{ cursor: 'pointer' }} />,
          ...InputProps,
        }}
        clearable
        clearLabel="Clear"
        error={error}
        helperText={helperText}
        InputLabelProps={{
          ...InputLabelProps,
          className: [classes.label, InputLabelProps.className].filter(Boolean).join(' '),
        }}
      />
    </MuiPickersUtilsProvider>
  );
}
